// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".info-table__main{position:relative}.info-table .show-more__button{padding:12px 0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
